import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function PainPoints() {
  const painPoints = ['Pasás horas en Pinterest juntando actividades sueltas que después no tienen secuencia ni coherencia', 'Arrancás cada semana sin saber bien qué trabajar ni en qué orden', 'Tus planificaciones son un collage de fotocopias, capturas y PDFs random', 'No tenés rúbricas claras y los informes te llevan fines de semana enteros', 'Querés hacer adaptaciones pero no sabés por dónde empezar', 'Sentís que improvisás más de lo que planificás', 'Los domingos a la noche terminás armando material con culpa y cansancio'];
  return <section className="w-full py-16 bg-[#111111]" data-id="element-187">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-188">
        <h2 className="md:text-4xl font-bold text-white mb-8 text-center font-['Open_Sans',_sans-serif] text-[20px]" data-id="element-189">
          Si sos psicopedagoga en Argetina,{' '}
          <span className="text-[#CAB072]" data-id="element-190">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 mb-12" data-id="element-191">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-3 bg-[#1A1A1A] p-4 rounded-lg border border-[#2A2A2A]" data-id="element-192">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-193" />
              <p className="text-gray-300" data-id="element-194">{point}</p>
            </div>)}
        </div>

        <div className="bg-[#0A0A0A] text-[#D4A843] p-8 rounded-lg text-center border border-[#D4A843]/30" data-id="element-195">
          <p className="text-xl md:text-2xl leading-relaxed font-[700] font-[Poppins,_sans-serif]" data-id="element-196">
            ¿Y si este fuera el último domingo que pasas así?
          </p>
        </div>
      </div>
    </section>;
}